/* LIST */
export const LIST_COUNTRIES = "LIST_COUNTRIES"
export const LIST_COUNTRIES_SUCCESS = "LIST_COUNTRIES_SUCCESS"
export const LIST_COUNTRIES_FAIL = "LIST_COUNTRIES_FAIL"
export const LIST_STAGES = "LIST_STAGES"
export const LIST_STAGES_SUCCESS = "LIST_STAGES_SUCCESS"
export const LIST_STAGES_FAIL = "LIST_STAGES_FAIL"
